import { JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationChecksComplete';
import { JoinAndAllocationDeclarations } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationDeclarations/JoinAndAllocationDeclarations';
import { Route } from 'react-router-dom';
import { KycInstruction } from '@dealstack/frontend/investor/pages/Investment/common/checksComplete/KycInstructions/KycInstruction';
import { InvestmentLeavePersonalIDs } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeaveChecksComplete/InvestmentLeavePersonalIDs/InvestmentLeavePersonalIDs';
import { InvestmentLeavePIVProof as InvestmentLeaveCompanyIDs } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeaveChecksComplete/InvestmentLeavePIVProof/InvestmentLeavePIVProof';
import { InvestmentKycForms } from '@dealstack/frontend/investor/pages/Investment/common/InvestmentKycForms';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { NoSaveStep } from '@dealstack/frontend/shared/components/Wizard/WizardStepRegistry';
import {
	GetInvestmentDetailsRes,
	KycWorkflowSettingResponseDto,
} from '@dealstack/shared/lib/generated';
import { getKycWorkflowId } from '@dealstack/frontend/investor/pages/Investment/common/getKycWorkflowId';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { isAnyCertificationRequired } from '@dealstack/shared/lib/common/business/kycCertification';

export enum INVESTMENT_LEAVE_CHECKS_COMPLETE_ROUTES {
	INSTRUCTIONS = '/instructions',
	PERSONAL = '/personal',
	COMPANY = '/company',
	KYC_FORMS = '/kyc-forms',
	DECLARATIONS = '/declarations',
}

interface Props {
	setIsContinueDisabled: (isContinueDisabled: boolean) => void;
	isPIVInvestment: boolean;
	investmentDetails?: GetInvestmentDetailsRes;
	kycSetting?: KycWorkflowSettingResponseDto;
}

export const InvestmentLeaveChecksComplete = ({
	setIsContinueDisabled,
	isPIVInvestment,
	investmentDetails,
	kycSetting,
}: Props) => {
	const isCertifiedCopiesRequested = isAnyCertificationRequired(kycSetting);

	const kycWorkflowId = getKycWorkflowId(investmentDetails);

	if (!kycWorkflowId) {
		return <InlineLoader />;
	}

	return (
		<SentryRoutes>
			<Route
				path={INVESTMENT_LEAVE_CHECKS_COMPLETE_ROUTES.INSTRUCTIONS}
				element={
					<NoSaveStep>
						<KycInstruction
							isCertifiedCopiesOfDocumentsRequested={isCertifiedCopiesRequested}
						/>
					</NoSaveStep>
				}
			/>

			<Route
				path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.PERSONAL}
				element={
					<InvestmentLeavePersonalIDs
						setIsContinueDisabled={setIsContinueDisabled}
						investmentDetails={investmentDetails}
						kycSetting={kycSetting}
					/>
				}
			/>
			<Route
				path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.COMPANY}
				element={
					<InvestmentLeaveCompanyIDs
						setIsContinueDisabled={setIsContinueDisabled}
						investmentDetails={investmentDetails}
						kycSetting={kycSetting}
					/>
				}
			/>
			<Route
				path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.KYC_FORMS}
				element={
					<InvestmentKycForms
						setIsContinueDisabled={setIsContinueDisabled}
						isPIVInvestment={isPIVInvestment}
						kycWorkflowId={kycWorkflowId}
					/>
				}
			/>
			<Route
				path={INVESTMENT_LEAVE_CHECKS_COMPLETE_ROUTES.DECLARATIONS}
				element={<JoinAndAllocationDeclarations />}
			/>
		</SentryRoutes>
	);
};
